<template>
            <main class="main">
              <organization_header :users="true"/>
              <loading-container :loading="loading" >
                <div class="worker">
                    <div class="worker-main">
                        <table class="worker-table">
                            <tr>
                                <th>Фамилия Имя</th>
                                <th width="27%">Роль</th>
                                <th>E-mail</th>
                                <th>Ссылка</th>
                                <th></th>
                            </tr>
                            <tr v-for="(invite, idx) in invites" :key="invite.id">
                              <td>{{invite.surname}} {{invite.name}}</td>
                              <td width="27%">{{invite.role}}</td>
                              <td>{{invite.email}}</td>
                              <td>https://superbaer24.ru/auth/registration?employee_key={{invite.key}}</td>
                              <td class="action">
                                <button @click="deleteInvite(invite.id, idx)">
                                  <img class="hover_btn" src="@/assets/img/worker/delete.svg" alt="">
                                </button>
                              </td>
                            </tr>
                        </table>
                    </div>
                </div>
              </loading-container>
            </main>
</template>

<script>
import organization_header from "@/components/OrganizationHeader.vue"
import LoadingContainer from "@/components/loading-container";


export default {
    name: "invite",
    data: function () {
        return {
          invites: [],
          loading: true
        }
    },
    components: {
      organization_header,
      LoadingContainer
    },
    mounted () {
        this.getInvites()
    },
    methods: {
        getInvites() {
          this.invites = [];
            if (localStorage.getItem('token')) {
                this.$http.post('/get-invites', {
                    token: localStorage.getItem('token')
                }).then(({data}) => {
                    if (data.invites) {
                      this.invites = data.invites
                    }
                })
                .catch((error) => {
                  console.log(error)
                })
                .finally(()=> {this.loading = false;})
            }
        },
        deleteInvite(id, key) {
          this.$http.post('/invite-remove', {
            token: localStorage.getItem('token'),
            id: id,
          }).then(({data}) => {
            if (data.success) {
              this.invites.splice(key, 1);
              this.$toast.success('Приглашение успешно удалено!');
            }
          }).catch((error) => {
            console.log(error)
          })
        }
    }
}
</script>

<style scoped lang="scss">
    .worker {
        &-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        }

        &-search {
            position: relative;
            width: 320px;

            > input {
                border: 1px solid #EEF0F3;
                box-sizing: border-box;
                border-radius: 4px;
                width: 100%;
                height: 40px;
                padding: 0 40px 0 15px;
                outline: none;
            }

            > img {
                position: absolute;
                right: 15px;
                bottom: 50%;
                transform: translateY(50%);
                width: 14px;
                height: 14px;
            }
        }

        &-add {
            background: #2CB181;
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
            height: 40px;
            border: none;
            outline: none;
            border-radius: 4px;
            width: 240px;
        }
    }
    th{
        img{
            margin-right: -11px;
            margin-left: 2px;
        }
    }
    .action {
      button {
        height: 20px;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        width: 20px;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
</style>
